import Vue from 'vue'
import Router from 'vue-router'
import { Loading } from 'element-ui';

import recruitIndex from '@/components/pages/recruit/recruitIndex.vue';

Vue.use(Router)

let loadingInstance;
let apinRoute = {
  show() {
    $("#loadingpage").show();
    // 加载中显示loading组件
    // loadingInstance = Loading.service({
    //   fullscreen: true,
    //   lock: true
    // });
  },
  resolve(resolve) {
    // 加载完成隐藏loading组件
    return component => {
      setTimeout(() => {
        // 关闭loading组件
        // loadingInstance.close();
        $("#loadingpage").hide();

        resolve(component)
      }, 10);
    }
  }
}

export default new Router({
  fallback: false, 
  mode: 'history',
  routes: [
    {
      path:'/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      //懒加载
      // component: resolve => require(['@/components/pages/index/index.vue'], resolve),
      component: resolve => {
        apinRoute.show();
        require(['@/components/pages/index/index.vue'], apinRoute.resolve(resolve))
      },
      meta: {
        title: '和风就职',
      }
    },
    {
      path: '/advantage',
      name: 'advantage',
      // component: resolve => require(['@/components/pages/advantage/index.vue'], resolve),
      component: resolve => {
        apinRoute.show();
        require(['@/components/pages/advantage/index.vue'], apinRoute.resolve(resolve))
      },
      meta: {
        title: '和风就职-和风优势'
      }
    },
    {
      path: '/policyIndex',
      name: 'policyIndex',
      // component: resolve => require(['@/components/pages/policy/policyIndex.vue'], resolve),
       component: resolve => {
         apinRoute.show();
         require(['@/components/pages/policy/policyIndex.vue'], apinRoute.resolve(resolve))
       },
      meta: {
        title: '和风就职-赴日政策',
        showIndex: true
      },
      children: [
        {
          path: '/policyDetail',
          name: 'policyDetail',
          // component: resolve => require(['@/components/pages/policy/policyDetail.vue'], resolve),
           component: resolve => {
             apinRoute.show();
             require(['@/components/pages/policy/policyDetail.vue'], apinRoute.resolve(resolve))
           },
          meta: {
            showIndex: false,
          }
        }
      ]
    },
    {
      path: '/recruitIndex',
      name: 'recruitIndex',
      // component: resolve => require(['@/components/pages/recruit/recruitIndex.vue'], resolve),
       component: resolve => {
         apinRoute.show();
         require(['@/components/pages/recruit/recruitIndex.vue'], apinRoute.resolve(resolve))
       },
      meta: {
        title: '和风就职-招聘岗位',
        showRecruitIndex: true,
      },
      children: [
        {
          path: '/recruitDetail',
          name: 'recruitDetail',
          // component: resolve => require(['@/components/pages/recruit/recruitDetail.vue'], resolve),
          component: resolve => {
            apinRoute.show();
            require(['@/components/pages/recruit/recruitDetail.vue'], apinRoute.resolve(resolve))
          },
          meta: {
            showRecruitIndex: false,
          }
        }
      ]
    },
    {
      path: '/form',
      name: 'form',
      // component: resolve => require(['@/components/pages/form/index.vue'], resolve),
       component: resolve => {
         apinRoute.show();
         require(['@/components/pages/form/index.vue'], apinRoute.resolve(resolve))
       },
      meta: {
        title: '和风就职-我要办理',
      }
    },
    {
      path: '/studyJob',
      name: 'studyJob',
      // component: resolve => require(['@/components/pages/form/index.vue'], resolve),
       component: resolve => {
         apinRoute.show();
         require(['@/components/pages/form/studyJob.vue'], apinRoute.resolve(resolve))
       },
      meta: {
        title: '和风就职-留学+就职咨询',
      }
    },
    // 404 处理
    {
      path: '*',
      redirect: '/index'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js